module.exports = __webpack_public_path__ + "static/google-play-badge-9b17b8945233868a76f5c70009489ff6.svg";